export const Letter = ({ letter }) => {
    return (
        <span>{letter} </span>
    )
}